import httpService from "../../services/httpService";

export const getUserDetails = (signal?: AbortSignal) => {
    return httpService.get('/api/users/me', { signal });
}

export const uploadUserAvatar = (formData: any) => {
    return httpService.patch('/api/users/me/avatar', formData, {
        headers: {
            "Content-Type": "multipart/form-data"
        }
    })
}

export const updateUser = (data: any) => {
    return httpService.patch('/api/users/me', data);
}

export const resetPassword = (data: any) => {
    return httpService.patch('/api/users/me/reset-pw', data);
}
